<script>
  import { getContext, onDestroy } from "svelte";
  import { mapbox, key } from "../mapbox.js";
  import { siteMarkers } from "../../stores.js";

  const { getMap } = getContext(key);
  const map = getMap();

  export let lat;
  export let lon;
  export let label;
  export let type;
  export let id = null;

  // Create a DOM element for each marker.
  const el = document.createElement("div");
  el.className = "marker map-icon-marker";

  switch (type) {
    case "load":
      el.style.backgroundImage = "url(./assests/green_pin.svg)";
      break;
    case "dispose":
      el.style.backgroundImage = "url(./assests/red_pin.svg)";
      break;
  }

  const popup = new mapbox.Popup({ offset: 25 }).setText(label || "");
  let marker = null;
  const latNum = parseFloat(lat);
  const lonNum = parseFloat(lon);

  if (map && !isNaN(latNum) && !isNaN(lonNum)) {
    marker = new mapbox.Marker(el)
      .setLngLat([lonNum, latNum])
      .setPopup(popup)
      .addTo(map);

    $siteMarkers = [
      ...$siteMarkers.filter((m) => m.marker !== marker),
      {
        marker: marker,
        label: label,
        id: id,
      },
    ];
  }

  $: if (marker && lat != null && lon != null && !isNaN(parseFloat(lat)) && !isNaN(parseFloat(lon))) {
    marker.setLngLat([parseFloat(lon), parseFloat(lat)]);
  }

  $: if (popup && label) {
    popup.setText(label);
  }

  onDestroy(() => {
    if (marker) {
      marker.remove();
    }
    $siteMarkers = $siteMarkers.filter((m) => m.marker !== marker);
  });
</script>
